function downloadFile(url, name, decode = false) {
  return new Promise(resolve => {
    if (!decode) {
      // Raw bytes version
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = name;
      downloadLink.target = '_blank';
      downloadLink.click();
      resolve();
    } else {
      // Base64 version
      decodeFileFromURL(url, response => {
        const downloadLink = document.createElement('a');
        downloadLink.href = response;
        downloadLink.download = name;
        downloadLink.target = '_blank';
        downloadLink.click();
        resolve();
      });
    }
  });
}

function decodeFileFromURL(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      var dataUrl = reader.result;
      var base64 = dataUrl.split(',')[1];
      base64 = atob(base64);
      callback(dataUrl.split(',')[0] + ',' + base64);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export const domHelper = {
  downloadFile
};
